<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 11L5 11M5 11L9 15M5 11L9 7" stroke="black" />
    <path d="M13 20L27 20M27 20L23 16M27 20L23 24" stroke="black" />
</svg>

